import React from 'react';
import DynamicFormSection from '../DynamicFormSection';
import { washroomConfig } from './washroomJson';

interface WashroomProps {
  onChange: React.Dispatch<React.SetStateAction<any>>;
  initialValues?: any;
}

const Washroom: React.FC<WashroomProps> = ({ onChange, initialValues }) => {
  return (
    <>
      {washroomConfig.map((section) => (
        <DynamicFormSection
          key={section.key}
          config={section}
          initialValue={initialValues?.[section.key]}
          onChange={(value) => {
            onChange((prev) => ({
              ...prev,
              [section.key]: value,
            }));
          }}
        />
      ))}
    </>
  );
};

export default Washroom;
